import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-441e2619"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = { class: "W-100 D-Flex FlexWrap" }
const _hoisted_5 = { class: "D-Flex F1_25em" }
const _hoisted_6 = {
  class: "P_5em color3",
  style: {"text-align":"start"}
}
const _hoisted_7 = { class: "F1_5em F-Bold D-Flex" }
const _hoisted_8 = { class: "V-Auto" }
const _hoisted_9 = { class: "D-Flex" }
const _hoisted_10 = { class: "V-Auto" }
const _hoisted_11 = { class: "D-Flex" }
const _hoisted_12 = { class: "V-Auto" }
const _hoisted_13 = {
  class: "",
  style: {}
}
const _hoisted_14 = {
  class: "BG2 P1em Rad3 D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  class: "",
  style: {"margin-inline-start":"auto"}
}
const _hoisted_17 = {
  class: "BG2 P1em Rad3 D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_18 = { class: "F1_75em" }
const _hoisted_19 = { class: "F_75em" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter" }, null, -1))
const _hoisted_21 = { class: "F_75em" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter" }, null, -1))
const _hoisted_23 = { class: "F1_75em" }
const _hoisted_24 = { class: "F_75em" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_26 = { class: "D-Flex" }
const _hoisted_27 = {
  class: "Rad3 F-Bold D-Flex M-Auto",
  style: {"padding":"0.3em 0.6em"}
}
const _hoisted_28 = { class: "O-75" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "P_25em" }, null, -1))
const _hoisted_30 = {
  key: 1,
  class: "CookiesRowSpacer"
}
const _hoisted_31 = {
  class: "D-Flex CookiesTimeline",
  style: {"flex-direction":"column"}
}
const _hoisted_32 = { class: "CheckpointHeader" }
const _hoisted_33 = { class: "F-Bold F1_25em" }
const _hoisted_34 = {
  class: "",
  style: {"width":"0.5em"}
}
const _hoisted_35 = { class: "CheckpointDetails P-Rel" }
const _hoisted_36 = {
  class: "P-Abs BG2 Rad1 D-Flex",
  style: {"inset-inline-end":"0","top":"0"}
}
const _hoisted_37 = {
  class: "M-Auto P_5em",
  style: {"margin-inline-start":"2em","height":"1.4em"}
}
const _hoisted_38 = ["href"]
const _hoisted_39 = {
  key: 0,
  class: "CookiesRowSpacer"
}
const _hoisted_40 = {
  key: 1,
  class: "D-Flex"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "P_5em" }, null, -1))
const _hoisted_42 = { class: "F1_75em" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_44 = {
  key: 1,
  class: ""
}
const _hoisted_45 = { class: "Strong" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  class: "D-Flex",
  style: {"margin-bottom":"2em"}
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CheckpointHeader" }, null, -1))
const _hoisted_49 = {
  key: 0,
  class: "",
  style: {"margin-bottom":"4em"}
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "",
  style: {"width":"0.5em"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "P-Rel Shadow1 D-Flex BGShade1 CheckpointIcon",
    style: {"margin-inline-start":"-0.75em"}
  })
], -1))
const _hoisted_51 = { class: "CheckpointDetails P-Rel" }
const _hoisted_52 = {
  class: "P-Abs Rad1 D-Flex",
  style: {"inset-inline-end":"0","top":"0","background":"none"}
}
const _hoisted_53 = {
  class: "M-Auto",
  style: {"margin-inline-start":"2em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesLoading = _resolveComponent("CookiesLoading")!

  return (_ctx.Access('Purchase_Vendors_Read'))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: 'CookiesDialog_' + _ctx.DialogIndex,
        class: "CookiesDialogdBody"
      }, [
        (_ctx.Saving)
          ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.Loading.length > 0)
          ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.Vendor?.Name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, "#" + _toDisplayString(_ctx.DeepFetcher(_ctx.Vendor, 'ID')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_CookiesIcon, {
                      class: "SQR1em V-Auto P_25em",
                      ID: 'Phone'
                    }),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.DeepFetcher(_ctx.Vendor, 'PhoneNumber')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_CookiesIcon, {
                    ToolTip: _ctx.Translate('Whatsapp'),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.OpenWhatsapp(_ctx.DeepFetcher(_ctx.Vendor, 'PhoneNumber')))),
                    class: "SQR1_5em HoverUp",
                    ID: 'Whatsapp'
                  }, null, 8, ["ToolTip"]),
                  _createElementVNode("a", {
                    href: `tel:${_ctx.Vendor?.PhoneNumber}`
                  }, [
                    _createVNode(_component_CookiesIcon, {
                      ToolTip: _ctx.Translate('Call'),
                      class: "SQR1_5em HoverUp",
                      ID: 'Phone'
                    }, null, 8, ["ToolTip"])
                  ], 8, _hoisted_15)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.Translate('Total')), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.DecimalFixer(_ctx.Total)), 1),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.PriceUnit), 1)
                  ]),
                  _hoisted_20,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.Translate('Remaining')), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["F2em F-Bold", _ctx.Total - _ctx.Paid === 0 ?  '' : _ctx.Vendor.Type === 'v' ? 'colorr1' : 'colorg3'])
                    }, _toDisplayString(_ctx.DecimalFixer(_ctx.Total - _ctx.Paid) * (_ctx.Vendor.Type === 'v' ? -1 : 1)), 3),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.PriceUnit), 1)
                  ]),
                  _hoisted_22,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.Vendor.Type === 'v' ? _ctx.Translate('Paid') : _ctx.Translate('Collected')), 1),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.DecimalFixer(_ctx.Paid)), 1),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.PriceUnit), 1)
                  ])
                ])
              ])
            ]),
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.Translate('Timeline')), 1),
                _hoisted_29,
                _createVNode(_component_CookiesIcon, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ReadDialogData())),
                  class: "SQR1_5em HoverUp",
                  ID: 'Recover'
                })
              ])
            ]),
            (_ctx.LoadingActions.length > 0)
              ? (_openBlock(), _createBlock(_component_CookiesLoading, {
                  key: 0,
                  class: "CookiesRowSpacer"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_30)),
            _createElementVNode("div", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SlicedActions, (Checkpoint, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "D-Flex",
                  style: {"margin-bottom":"4em"}
                }, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.JsonDateParser(_ctx.DeepFetcher(Checkpoint, 'Date'))), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.DateFormatter(_ctx.DeepFetcher(Checkpoint, 'Date'), 'FullDay')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", {
                      class: "P-Rel Shadow1 D-Flex BG2 CheckpointIcon",
                      style: _normalizeStyle(`border: solid 0.3em ${Checkpoint.Color}`)
                    }, [
                      _createVNode(_component_CookiesIcon, {
                        class: "M-Auto O-50",
                        style: {"width":"60%","height":"60%","filter":"saturate(0)"},
                        ID: Checkpoint.Icon
                      }, null, 8, ["ID"])
                    ], 4),
                    _createElementVNode("div", {
                      class: "H-100 Rad3",
                      style: _normalizeStyle(`background-color: ${Checkpoint.Color}`)
                    }, null, 4)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.Translate(Checkpoint?.PointTitle)), 1),
                      (Checkpoint.Buttons)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Checkpoint.Buttons, (button, index) => {
                            return (_openBlock(), _createElementBlock("a", {
                              target: "_blank",
                              href: button.Link,
                              key: index
                            }, [
                              _createVNode(_component_CookiesIcon, {
                                style: {"width":"1.4em","height":"1.4em"},
                                class: "W-100 H-100 HoverUp Pointer P_5em",
                                Tooltip: _ctx.Translate(button.Tooltip),
                                ID: button.Icon
                              }, null, 8, ["Tooltip", "ID"])
                            ], 8, _hoisted_38))
                          }), 128))
                        : _createCommentVNode("", true)
                    ]),
                    (Checkpoint.PointName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39))
                      : _createCommentVNode("", true),
                    (Checkpoint.PointName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("strong", _hoisted_42, _toDisplayString(Checkpoint.PointName), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_43,
                    (Checkpoint.PointData)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(Checkpoint.PointData, (pointData, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["D-Flex P_25em", [pointData.Border && index > 0 ? 'PointBorderTop' : '', pointData.Class]]),
                            style: _normalizeStyle([{"gap":"0.5em"}, pointData.Style]),
                            key: index
                          }, [
                            (pointData.Icon)
                              ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                                  key: 0,
                                  class: "SQR1_5em V-Auto O-75",
                                  ID: pointData.Icon,
                                  style: {"filter":"saturate(0)"}
                                }, null, 8, ["ID"]))
                              : _createCommentVNode("", true),
                            (pointData.Name)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(pointData.Name) + ":", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_45, [
                              (pointData.ID)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, "#"))
                                : _createCommentVNode("", true),
                              _createTextVNode(_toDisplayString(pointData.Value), 1)
                            ])
                          ], 6))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                (_ctx.Views < _ctx.CustomerActions.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Views += 5))
                      }, _toDisplayString(_ctx.Translate('Load More')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_50,
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.CustomerActions.length > 0 ? '': _ctx.LoadingActions.length > 0 ? _ctx.Translate('Loading') + '...': _ctx.Translate('No Data')), 1)
                        ])
                      ])
                    ], 64))
              ])
            ])
          ])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}